/**
 * @file FormField 表单字段布局
 * @description Label + 控件 + hint/error 的标准垂直布局。
 *
 * @whenToUse 几乎所有表单项包裹。
 * @whenNotToUse 工具栏内联紧凑控件（可直接用 Input 无 Label）。
 */

import type { ReactNode } from 'react'
import { Label } from '@/components/ui/label.tsx'
import { cn } from '@/lib/cn.ts'

export type FormFieldProps = {
  /** 字段标签 */
  label?: ReactNode
  /** 指向控件 id */
  htmlFor?: string
  /** 必填标记 */
  required?: boolean
  /** 错误文案（优先于 hint） */
  error?: ReactNode
  /** 辅助说明 */
  hint?: ReactNode
  /** 控件 */
  children: ReactNode
  className?: string
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label ? (
        <Label htmlFor={htmlFor} required={required}>
          {label}
        </Label>
      ) : null}
      {children}
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-muted">{hint}</p>
      ) : null}
    </div>
  )
}
